
export const API = process.env.REACT_APP_API;

export const API_AGENDA_RIMAC = process.env.REACT_APP_API_AGENDA_RIMAC || '';
export const API_EXPLORATORIO_RIMAC = process.env.REACT_APP_API_EXPLORATORIO_RIMAC || '';

export const COGNITO = {
  REGION: process.env.REACT_APP_COGNITO_REGION,
  USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
  BUCKET_S3: process.env.REACT_APP_AMPLIFY_S3,
  IDENTITY_POOL_ID: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  USER_POOL_DOMAIN_NAME: process.env.REACT_APP_COGNITO_USER_POOL_DOMAIN_NAME,
  OAUTH_PATH: process.env.REACT_APP_COGNITO_OAUTH_PATH,
  OAUTH_PROVIDER: process.env.REACT_APP_COGNITO_OAUTH_PROVIDER,
  OAUTH_RESPONSE_TYPE: process.env.REACT_APP_COGNITO_OAUTH_RESPONSE_TYPE,
  OAUTH_SCOPE: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin']
};

export const API_GATEWAY = {
  NAME: process.env.REACT_APP_API_GATEWAY_NAME,
  REGION: process.env.REACT_APP_API_GATEWAY_REGION,
  URL: process.env.REACT_APP_API_GATEWAY_URL
};

export const API_GATEWAY_MVI = {
  NAME: process.env.REACT_APP_API_GATEWAY_MVI_NAME,
  REGION: process.env.REACT_APP_API_GATEWAY_MVI_REGION,
  URL: process.env.REACT_APP_API_GATEWAY_MVI_URL
};

export const TIPO_SOLICITUDES = {
  TAB_0: process.env.REACT_APP_TIPO_SOLICITUD_TAB_0,
  TAB_0_DESC: process.env.REACT_APP_TIPO_SOLICITUD_TAB_0_DESCRIPCION,
  TAB_0_1: process.env.REACT_APP_TIPO_SOLICITUD_TAB_0_1,
  TAB_0_1_DESC: process.env.REACT_APP_TIPO_SOLICITUD_TAB_0_1_DESCRIPCION,
  TAB_1: process.env.REACT_APP_TIPO_SOLICITUD_TAB_1,
  TAB_2: process.env.REACT_APP_TIPO_SOLICITUD_TAB_2,
  TAB_2_DESC: process.env.REACT_APP_TIPO_SOLICITUD_TAB_2_DESCRIPCION,
  TAB_3: process.env.REACT_APP_TIPO_SOLICITUD_TAB_3,
  TAB_1_DESC: process.env.REACT_APP_TIPO_SOLICITUD_TAB_1_DESCRIPCION,
};

export const TIPO_SOLICITUDES_A_DISTRIBUIR = {
  TAB_0: process.env.REACT_APP_TIPO_SOL_A_DISTRIBUIR_TAB_0,
  TAB_1: process.env.REACT_APP_TIPO_SOL_A_DISTRIBUIR_TAB_1,
  TAB_2: process.env.REACT_APP_TIPO_SOL_A_DISTRIBUIR_TAB_2,
  TAB_1_ESTADOS: process.env.REACT_APP_TIPO_SOLICITUD_DISTRIBUCION_TAB_1,
  TAB_1_ESTADOS_DESC: process.env.REACT_APP_TIPO_SOLICITUD_DISTRIBUCION_TAB_1_DESCRIPCION,
  TAB_2_ESTADOS: process.env.REACT_APP_TIPO_SOLICITUD_DISTRIBUCION_TAB_2,
  TAB_2_ESTADOS_DESC: process.env.REACT_APP_TIPO_SOLICITUD_DISTRIBUCION_TAB_2_DESCRIPCION
}

export const TIPO_SOLICITUDES_AUTORIZACIONES = {
  TAB_0: process.env.REACT_APP_TIPO_SOLICITUD_AUTORIZACIONES_TAB_0
}

export const FILTRO_TIPO_VIA = {
  TAB: process.env.REACT_APP_FILTRO_TIPO_VIA_A_DISTRIBUIR_TAB,
  TAB_DESC: process.env.REACT_APP_FILTRO_TIPO_VIA_A_DISTRIBUIR_TAB_DESC
}

export const FILTRO_TIPO_DOCUMENTO_BUSQ = {
  TAB: process.env.REACT_APP_FILTRO_TIPO_DOCUMENTO_BUSQ_TAB,
  TAB_DESC: process.env.REACT_APP_FILTRO_TIPO_DOCUMENTO_BUSQ_TAB_DESC
  // TAB: "ruc|nroSolic|dni",
  // TAB_DESC: "RUC|Nro. Solicitud|DNI"
}

export const EXCHANGE_RATE = {
  REQUEST_PAYLOAD_CURRENCY_SOL: "SOL",
  REQUEST_PAYLOAD_CURRENCY_USD: "USD"
};

export const CONSTANTS = {
  CURRENCY_TYPE_USD: 1,
  CURRENCY_TYPE_SOL: 2,
};

export const PATH_APP = {
  DOMAIN: process.env.NODE_ENV !== 'production' ? 'http://localhost:3000' : process.env.REACT_APP_DOMAIN
};

export const AMPLIFY_CONF = {
  MANDATORY_SIGN_IN: true,
  REGION: COGNITO.REGION,
  USER_POOL_ID: COGNITO.USER_POOL_ID,
  IDENTITY_POOL_ID: COGNITO.IDENTITY_POOL_ID,
  USER_POOL_WEB_CLIENT_ID: COGNITO.APP_CLIENT_ID,
  BUCKET_S3: COGNITO.BUCKET_S3,
  OAUTH: {
    DOMAIN: COGNITO.USER_POOL_DOMAIN_NAME,
    REDIRECT_SIGNIN: PATH_APP.DOMAIN + '/',
    REDIRECT_SIGNOUT: PATH_APP.DOMAIN + '/',
    RESPONSE_TYPE: COGNITO.OAUTH_RESPONSE_TYPE,
    SCOPE: COGNITO.OAUTH_SCOPE,
  }
};

export const TIPO_SOLICITUDES_A_MARCAR : any = process.env.REACT_APP_TIPO_SOLICITUDES_MARCA;
export const IND_HABILITAR_MARCA_MANUAL_SOLIC = process.env.REACT_APP_IND_HABILITAR_MARCA_MANUAL_SOLIC;

export const USUARIO_API = process.env.REACT_APP_USUARIO_API;
export const WARNING_DISTRIBUIDAS = process.env.REACT_APP_WARNING_DISTRIBUIDAS;

export const POPUP_ORDEN_CONFIRMACION = {
  CLASS: "modal-aprobar-rechazar",
  ASUNTO: "¡ATENCIÓN!",
  ASUNTO_RESALTADO: "",
  TEXTO: "¿Está seguro de APROBAR esta cotización?",
  BTN_TEXTO: "CANCELAR",
  BTN_TEXTO_Confirma: "SI, APROBAR",
  IMG: "brotherpensativo",
  IND_OPERACION: 1
}

export const POPUP_ORDEN_RECHAZO = {
  CLASS: "modal-aprobar-rechazar",
  ASUNTO: "¡ATENCIÓN!",
  ASUNTO_RESALTADO: "",
  TEXTO: "¿Está seguro de RECHAZAR esta cotización?",
  BTN_TEXTO: "CANCELAR",
  BTN_TEXTO_Confirma: "SI, RECHAZAR",
  IMG: "brotherpensativo",
  IND_OPERACION: 2
}
